import jsonExport from 'jsonexport/dist';
import moment from 'moment';
import 'moment/locale/fr';
import ExcelJS from 'exceljs';

let cache = {};
let namedouble = [];
let namedoubleRegul = [];

function formatOrdersForExport(data) {
  const allIndicatorKeys = new Set();
  const accroissementKeys = new Set();
  const empoissonnementKeys = new Set();
  const pecheKeys = new Set();
  const coeffMultiplicateurKeys = new Set();

  data.forEach(item => {
    Object.entries(item.indicators).forEach(([key, value]) => {
      allIndicatorKeys.add(key);
      if (key === "coeff_accroissement_globaux" && typeof value === 'object') {
        Object.keys(value).forEach(k => accroissementKeys.add(k));
      }
      if (key === "empoissonnement_kg_ha_spieces" && typeof value === 'object') {
        Object.keys(value).forEach(k => empoissonnementKeys.add(k));
      }
      if (key === "peche_kg_ha_spieces" && typeof value === 'object') {
        Object.keys(value).forEach(k => pecheKeys.add(k));
      }
      if (key === "coeff_multiplicateur" && typeof value === 'object') {
        Object.keys(value).forEach(k => coeffMultiplicateurKeys.add(k));
      }
    });

    if (item.waterBody?.protectionsCormorans) {
      Object.keys(item.waterBody.protectionsCormorans).forEach(key => {
        addToIfNotExist(namedouble, key);
      });
    }
    if (item.waterBody?.donneesRegulations) {
      Object.keys(item.waterBody.donneesRegulations).forEach(key => {
        addToIfNotExist(namedoubleRegul, key);
      });
    }
  });

  const formattedData = data.map(item => {
    const formattedItem = {
      "Date Début Campagne": moment(item.campaign.startDate).format('YYYY-MM-DD'),
      "Date Fin Campagne": moment(item.campaign.endDate).format('YYYY-MM-DD'),
      "Nom Prénom": `${item.waterBody.user.firstName || 'N/A'} ${item.waterBody.user.lastName || 'N/A'}`,
      "Nom Étang": item.waterBody.name,
      "Niveau technique de l'exploitant": item.waterBody.user.technicalLevel,
      "Collecteur de l'étang": item.waterBody.currentCollector.name,
      "Superficie Étang": item.waterBody.waterSurface,
      "Ville": item.waterBody.town,
      "Propriétaire Actuel": item.waterBody.currentOwner || 'N/A',
      "Profondeur Moyenne": item.waterBody.averageDepth || 'N/A',
      "Aérateur": item.waterBody.aerator ? 'Oui' : 'Non',
      "Électricité": item.waterBody.electricity ? 'Oui' : 'Non',
      "Nourrisseur": item.waterBody.feeder ? 'Oui' : 'Non',
      "Distance": item.waterBody.distance || 'N/A',
    };

    allIndicatorKeys.forEach(key => {
      if (key === "coeff_accroissement_globaux") {
        accroissementKeys.forEach(k => {
          const value = item.indicators[key]?.[k];
          formattedItem[`Accroissement ${k}`] = value !== undefined ? value : 'N/A';
        });
      } else if (key === "empoissonnement_kg_ha_spieces") {
        empoissonnementKeys.forEach(k => {
          const value = item.indicators[key]?.[k];
          formattedItem[`Empoissonnage en kg / ha par ${k}`] = value !== undefined ? value : 'N/A';
        });
      } else if (key === "peche_kg_ha_spieces") {
        pecheKeys.forEach(k => {
          const value = item.indicators[key]?.[k];
          formattedItem[`Peche en kg / ha par ${k}`] = value !== undefined ? value : 'N/A';
        });
      } else if (key === "coeff_multiplicateur") {
        coeffMultiplicateurKeys.forEach(k => {
          const value = item.indicators[key]?.[k];
          formattedItem[`Coeff multiplicateur par ${k}`] = value !== undefined ? value : 'N/A';
        });
      } else {
        formattedItem[key] = item.indicators[key] !== undefined ? item.indicators[key] : 'N/A';
      }
    });

    const additionalColumns = {
      "Dates Aération": item.waterBody.datesAeration?.map(d =>
          `${moment(d.startDate).format('YYYY/MM/DD')} ${moment(d.startTime, 'HH:mm:ss').format('HH:mm')} - ${moment(d.endDate).format('YYYY/MM/DD')} ${moment(d.endTime, 'HH:mm:ss').format('HH:mm')}`
      ).join(', ') || 'N/A',

      "Coût de Pompage": item.waterBody.coutPompage?.map(p => p.estimatedCost).join(', ') || 'N/A',
      "Temps de Pêche Pêcheurs": item.waterBody.tempsPeche?.map(p => `${p.fishermenNumber}`).join(', ') || 'N/A',
      "Temps de Pêche Coût": item.waterBody.tempsPeche?.map(p => `${p.estimatedCost}`).join(', ') || 'N/A',
      "Temps de Pêche": item.waterBody.tempsPeche?.map(p => `${p.fishingTime}`).join(', ') || 'N/A',
      "Travaux d'Entretien": item.waterBody.travauxEntretien?.map(t => `Travail réalisé: ${t.workDone}, Coût estimé: ${t.estimatedCost}`).join(', ') || 'N/A',
      "Coût Fertilisation": item.waterBody.coutFertilization?.map(cf => cf.estimatedCost).join(', ') || 'N/A',
      "Prix Chaulage": item.waterBody.prixChaulage?.map(pc => pc.purchasePrice * pc.quantity).join(', ') || 'N/A'
    };

    namedouble.forEach(key => {
      additionalColumns["Protections Cormorans " + key] =
          item.waterBody.protectionsCormorans?.[key]?.[0]?.number ?? 'N/A';
    });

    namedoubleRegul.forEach(key => {
      additionalColumns["Données Régulations " + key] =
          item.waterBody.donneesRegulations?.[key] ?? 'N/A';
    });

    return { ...formattedItem, ...additionalColumns };
  });

  // Supprimer les colonnes dont toutes les valeurs sont "N/A"
  const columnsToRemove = new Set();
  if (formattedData.length > 0) {
    const allKeys = Object.keys(formattedData[0]);
    allKeys.forEach(key => {
      const allAreNA = formattedData.every(row => row[key] === 'N/A');
      if (allAreNA) {
        columnsToRemove.add(key);
      }
    });
  }

  const cleanedData = formattedData.map(row => {
    const newRow = { ...row };
    columnsToRemove.forEach(col => delete newRow[col]);
    return newRow;
  });

  return cleanedData;
}

export async function orderExporter(data, fetchRelatedRecords, dataProvider, exportFileName) {
  const ordersForExport = formatOrdersForExport(data);
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(exportFileName);
  const headerRow = worksheet.addRow(Object.keys(ordersForExport[0]));
  headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  headerRow.eachCell(cell => {
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    if (cell.value) {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '4e73df' }
      };
    }
  });

  ordersForExport.forEach(order => {
    const row = worksheet.addRow(Object.values(order));
    row.eachCell(cell => {
      cell.alignment = { horizontal: 'left' };
    });
  });
  worksheet.getRow(1).height = 30;

  const defaultColumnWidth = 20;
  const specificColumnWidths = {
    2: 28,
    6: 25,
    10: 25
  };
  worksheet.columns.forEach((column, columnIndex) => {
    column.width = specificColumnWidths[columnIndex + 1] || defaultColumnWidth;
  });
  workbook.xlsx.writeBuffer().then(buffer => {
    downloadExcel(buffer, exportFileName);
  });
}

const downloadExcel = (buffer, filename) => {
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}.xlsx`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

function clearCache() {
  cache = {};
}

function addToIfNotExist(array, item) {
  if (!array.includes(item)) {
    array.push(item);
    return true;
  }
  return false;
}

clearCache();

export default orderExporter;
